var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.78516 6.25L11.4062 2.66406L12.1445 1.92578C12.25 1.82031 12.25 1.64453 12.1445 1.50391L11.3711 0.730469C11.2305 0.625 11.0547 0.625 10.9492 0.730469L6.625 5.08984L2.26562 0.730469C2.16016 0.625 1.98438 0.625 1.84375 0.730469L1.07031 1.50391C0.964844 1.64453 0.964844 1.82031 1.07031 1.92578L5.42969 6.25L1.07031 10.6094C0.964844 10.7148 0.964844 10.8906 1.07031 11.0312L1.84375 11.8047C1.98438 11.9102 2.16016 11.9102 2.26562 11.8047L6.625 7.44531L10.2109 11.0664L10.9492 11.8047C11.0547 11.9102 11.2305 11.9102 11.3711 11.8047L12.1445 11.0312C12.25 10.8906 12.25 10.7148 12.1445 10.6094L7.78516 6.25Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.b8f8e9d2.svg";
export { ForwardRef as ReactComponent };